import {
    CATALOG_CREATE,
    CATALOG_FETCH
} from '../actions/types';

const INITIAL_STATE = { 
    catalogs: null,
    loading: false
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case CATALOG_CREATE:
            return { ...state, loading: action.payload }
        case CATALOG_FETCH:
            return { ...state, catalogs: action.payload }
        default:
            return state
    }
}